<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/10016.jpg" alt="">
        </div>
        <div class="cen_box">
            <div class="cen_box_box">
                <h1>About ISFAL</h1>
                <div class="cen_box_box_1">
                    <img src="../../assets/images/isfal/10017.jpg" alt="">
                    <div class="cen_box_box_1_1">
                        <p class="cen_box_box_1_1_1">Introduction to ISFAL</p>
                        <p>In 1971, Mr. Reg Ravens formally put forward the concept and method of action learning, which
                            has been widely spread and applied in business organizations, education, medical care,
                            social welfare and government all over the world.</p>
                        <br />
                        <br />
                        <p>

                        </p>
                        <p>In order to better promote the innovative practice and theoretical research of action
                            learning, action learning experts from all over the world, Christine Abbott (UK), Michael
                            Weiss (Austria), Thomas Tang (China) and Genevieve Cother (Australia), jointly initiated the
                            establishment of the International Society for Action Learning, hereinafter referred to as
                            ISFAL. The first team of action learning experts who joined ISFAL included Mike Pedler (UK),
                            Tom Boydell (UK) and Yunong Li (USA). ISFAL is registered in Austria and headquartered in
                            London, England.</p>
                    </div>
                </div>
                <div class="cen_box_box_2">
                    <p>
                        ISFAL has connected a number of global partners (the first batch): CFAL(Center For Action
                        Learning), ALI(The Action Learning Institute), HDNW(Home of sustainable economy), CSAL (China
                        Society for Action Learning), Action Learning: Research and Practice, Training Magazine (China),
                        Electronic Industry Press (China), Ivy League and other institutions and other institutions
                        jointly promote the practice, innovation and research of action learning.
                    </p>
                    <br />
                    <br />
                    <p>
                        ISFAL connects with action learning experts all over the world, and we will devote ourselves to
                        strengthening the international exchange of action learning practitioners and innovating the
                        innovative application of action learning methods and technologies, especially in the field of
                        organizational development; At the same time, deepen the theoretical research of dynamic
                        learning and cultivate international professional talents of action learning! So as to realize
                        the sustainable development of action learning in the world!
                    </p>
                    <br />
                    <br />
                    <div style="font-size:16px;">
                        <p>As of today, ISFAL consist of five global affiliates located around the world, dedicated to
                            serving action learning practice and research in their locations.</p>
                        <div style="display: flex; justify-content: space-between;">
                            <div style="margin-top:20px;">
                                <p>These five affiliates are:</p>
                                <p style="margin-top:5px;">Affiliate in Europe-UK</p>
                                <p style="margin-top:5px;">Affiliate in Europe-Austria</p>
                                <p style="margin-top:5px;">Affiliate in Asia-China</p>
                                <p style="margin-top:5px;">Affiliate in Oceania-Australia,</p>
                                <p style="margin-top:5px;">Affiliate in North America-USA ,</p>
                            </div>
                            <div style="width: 300px;margin-bottom:20px;margin-right:30px;" >
                                <img src="../../assets/images/isfal/map.png" alt="">
                            </div>
                        </div>
                        <p>
                            They are responsible for the operation and development of their respective regions.
                            The five affiliates maintain close communication and collaboration, share resources and
                            technology, and realize complementary advantages.
                        </p>
                    </div>
                    <br />
                    <br />
                    <p>
                        ISFAL is the home of global action learning practitioners and researchers. We warmly welcome you
                        to join ISFAL. We will work together to make ourselves, our organization and the world better
                        with action learning!
                    </p>
                </div>
                <div class="cen_box_box_3">
                    <div class="cen_box_box_3_1">
                        <img src="../../assets/images/isfal/10018.jpg" alt="">
                        <p class="name">Mission</p>
                        <p class="infio">To promote the innovative practice and sharing of global action learning for
                            personal growth, organisational development and social progress.</p>
                    </div>
                    <div class="cen_box_box_3_1">
                        <img src="../../assets/images/isfal/10019.jpg" alt="">
                        <p class="name">Vision</p>
                        <p class="infio">An ecological alliance for global action learning practitioners to learn and
                            grow.</p>
                    </div>
                    <div class="cen_box_box_3_1">
                        <img src="../../assets/images/isfal/10020.jpg" alt="">
                        <p class="name">Core Values</p>
                        <p class="infio">
                            Diversity and inclusiveness , Sincerity and Mutuality, Integration and Innovation,
                            Collaboration and Win-Win.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {

            }
        },
        components: {},

        //方法集合
        methods: {

        },
        created() {

        },
        mounted() {

        }
    }
</script>
<style scoped lang="less">
    .About_ISFAL {
        background-color: #fff;
    }
</style>